var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-wrap"},[_c('p',{staticClass:"pointer"}),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.titleName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }